/* eslint-disable */
// /src/pages/LocalAffiliatesHome.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";
import RegionCard from "../components/RegionCard";
import { useAppConfig } from "../context/AppConfigContext";

// 기본 이미지 자산 (어드민 설정이 없을 때/이미지 비었을 때 사용)
import imgGangwon from "../assets/images/regions/gangwon.png";
import imgGyeonggi from "../assets/images/regions/gyeonggi.png";
import imgUlsan from "../assets/images/regions/ulsan.png";
import imgJeonbuk from "../assets/images/regions/jeonbuk.png";
import imgChungnam from "../assets/images/regions/chungnam.png";
import imgChungbuk from "../assets/images/regions/chungbuk.png";

/* ===== 스타일 ===== */
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  &,
  * {
    box-sizing: border-box;
  }
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`;


const Body = styled.div`
  flex: 1;
  padding: 16px 10px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  row-gap: 14px;
  overflow-y: auto;
`;

const Grid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-width: 0;
  overflow-x: hidden;

  @media (min-width: 720px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

/* ===== Fallback(기본) 지역 목록 ===== */
const FALLBACK_ITEMS = [
  { id: "gyeonggi", name: "경기도", img: imgGyeonggi, accent: "#7DB3FF" },
  { id: "gangwon", name: "강원도", img: imgGangwon, accent: "#7FCF91" },
  { id: "ulsan", name: "울산광역시", img: imgUlsan, accent: "#6FA9FF" },
  { id: "jeonbuk", name: "전라북도", img: imgJeonbuk, accent: "#8EC5FF" },
  { id: "chungnam", name: "충청남도", img: imgChungnam, accent: "#A3E3B2" },
  { id: "chungbuk", name: "충청북도", img: imgChungbuk, accent: "#9FD2FF" },
];

export default function LocalAffiliatesHome() {
  const nav = useNavigate();

  const goRegion = (regionName) => {
    nav(`/partners?region=${encodeURIComponent(regionName)}`);
  };

  // 🔹 AppConfig에서 관리자 설정 읽기 (detailScreens.localPartners.slots)
  const { config } = useAppConfig();
  const detail = config.detailScreens || {};
  const localPartnersCfg = detail.localPartners || {};
  const slots = Array.isArray(localPartnersCfg.slots)
    ? localPartnersCfg.slots
    : [];

  // 🔹 우선순위: detailScreens.localPartners.slots → (예전 구조) config.localAffiliates.regions → FALLBACK_ITEMS
  // 여기서는 slots만 사용 (관리자 AdminDetailScreens 에서 관리하는 6개 슬롯)
  const items =
    slots.length > 0
      ? slots.map((slot, idx) => {
        const fb = FALLBACK_ITEMS[idx] || {};
        return {
          // id는 슬롯 id가 있으면 그걸, 없으면 fallback id, 그것도 없으면 slot1..6
          id: slot.id || fb.id || `slot${idx + 1}`,
          // 제목: 관리자 설정이 우선, 없으면 기본 지역명
          name: slot.title || fb.name || "지역명",
          // 이미지: 관리자 설정 imageUrl → fallback 이미지 → 경기도 이미지
          img: slot.imageUrl || fb.img || imgGyeonggi,
          // accent 색은 기존 fallback 기준 유지
          accent: fb.accent || "#7DB3FF",
        };
      })
      : FALLBACK_ITEMS;

  return (
    <Wrap>
      <Sheet>
        <PageTopBar />

        <Body>
          <BrandHeader subtitle="로컬 제휴 서비스" />
          <Grid>
            {items.map((r) => (
              <RegionCard
                key={r.id}
                title={r.name}
                imgSrc={r.img}
                accent={r.accent}
                onClick={() => goRegion(r.name)}
              />
            ))}
          </Grid>
          <BottomPad />
        </Body>
      </Sheet>
    </Wrap>
  );
}
